/** The product name, as the Wordmark sets it (D58). */
export const brandCopy = { name: 'chroma' } as const
